import { z } from 'zod';

/** shortcut: o `/me.homeIsland` da extinta flag `use_intelligence_home_island`. O web-chat parseia o
 *  `/me` em modo estrito e já não lê a chave, mas um BFF anterior ainda a manda enquanto o deploy
 *  sobe; remover depois que o app-integration sem ela estiver em prod. */
export const HomeIslandEntrySchema = z.object({ offer: z.boolean() }).strict();
